import { render, staticRenderFns } from "./MediaLanguageSelector.vue?vue&type=template&id=1b5f9ce8&"
import script from "./MediaLanguageSelector.vue?vue&type=script&lang=js&"
export * from "./MediaLanguageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports